'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/progress/styles.css';
import { ImageWithFallback } from 'BomdisoftComponents/image-with-fallback/index';
import { getLanguageFromLocale, loadingT } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type PulsatingProgressIndicatorProps = {
  image: string;
  width?: number;
  height?: number;
};

export const PulsatingProgressIndicator = ({ image, width = 60, height = 60 }: PulsatingProgressIndicatorProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);
  return (
    <div className='bomdisoft-progress-container'>
      <div aria-label={loadingT[language]} className='bomdisoft-progress-loader' role='progressbar'>
        <span />
        <span />
        <span />
        <span />
      </div>
      <ImageWithFallback alt='' className='bomdisoft-progress-image' height={height} priority src={image} width={width} />
    </div>
  );
};
